<template>
	<div class="self-signup-form-fields">
		<v-form v-model="valid">
			<v-text-field
				v-model="firstName"
				:rules="firstNameRules"
				label="Prénom *"
				required
				outlined
				color="#7854f7"
				data-testid="selfSignupFirstName"
				@click="clearError"
			></v-text-field>
			<v-text-field
				v-model="lastName"
				:rules="lastNameRules"
				label="Nom *"
				required
				outlined
				color="#7854f7"
				data-testid="selfSignupLastName"
				@click="clearError"
			></v-text-field>
			<v-text-field
				v-model="email"
				:rules="emailRules"
				label="Adresse email *"
				required
				outlined
				color="#7854f7"
				data-testid="selfSignupEmail"
				@click="clearError"
			></v-text-field>
			<div v-if="allowSelectGroup" class="hierarchy-section">
				<p class="hierarchy-label">Groupe *</p>
				<SelfSignupHierarchyTree v-model="selectedGroup" :hierarchy="hierarchy" />
				<p v-if="showGroupRequiredHint" class="group-hint">Sélectionne un groupe</p>
			</div>
		</v-form>
		<p v-if="errorMessage" class="self-signup-error" data-testid="selfSignupFormError">
			{{ errorMessage }}
		</p>
		<div class="button-validate">
			<v-btn
				:disabled="!canSubmit"
				:loading="loading"
				depressed
				large
				color="#15c39a"
				class="hvr-grow"
				data-testid="selfSignupSubmit"
				@click="onSubmit"
			>
				<span class="white--text">S'inscrire</span>
			</v-btn>
		</div>
	</div>
</template>

<script>
import SelfSignupHierarchyTree from './SelfSignupHierarchyTree.vue';

export default {
	name: 'SelfSignupForm',
	components: {
		SelfSignupHierarchyTree,
	},
	props: {
		allowSelectGroup: {
			type: Boolean,
			default: false,
		},
		hierarchy: {
			type: Array,
			default: function () {
				return [];
			},
		},
		loading: {
			type: Boolean,
			default: false,
		},
		errorMessage: {
			type: String,
			default: '',
		},
	},
	data: function () {
		return {
			valid: false,
			firstName: '',
			lastName: '',
			email: '',
			selectedGroup: null,
			attemptedSubmit: false,
			firstNameRules: [(v) => !!v || 'Saisis ton prénom'],
			lastNameRules: [(v) => !!v || 'Saisis ton nom'],
			emailRules: [
				(v) => !!v || "L'adresse email est un champ obligatoire",
				(v) => /.+@.+/.test(v) || "L'adresse email n'est pas valide",
			],
		};
	},
	computed: {
		hasRequiredGroup: function () {
			if (!this.allowSelectGroup) {
				return true;
			}
			return this.selectedGroup != null;
		},
		canSubmit: function () {
			return this.valid && this.hasRequiredGroup && !this.loading;
		},
		showGroupRequiredHint: function () {
			return this.allowSelectGroup && this.attemptedSubmit && this.selectedGroup == null;
		},
	},
	methods: {
		clearError: function () {
			this.$emit('clear-error');
		},
		onSubmit: function () {
			this.attemptedSubmit = true;
			if (!this.canSubmit) {
				return;
			}
			this.$emit('submit', {
				firstName: this.firstName,
				lastName: this.lastName,
				email: this.email.toLowerCase(),
				selectedGroup: this.selectedGroup,
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.self-signup-form-fields {
	padding: 8px 4px 8px;
}

@media (min-width: 960px) {
	.self-signup-form-fields {
		border: 1px solid #e0e0e0;
		border-radius: 12px;
		padding: 28px 32px 20px;
		background: #fff;
	}
}

.button-validate {
	text-align: center;
	padding-bottom: 12px;
	padding-top: 8px;
}
.self-signup-error {
	text-align: center;
	color: #c62828;
	font-size: 16px;
	margin: 0 0 16px;
}
.hierarchy-label {
	font-size: 14px;
	margin-bottom: 8px;
	color: rgba(0, 0, 0, 0.6);
}
.group-hint {
	color: #c62828;
	font-size: 12px;
	margin-top: -8px;
	margin-bottom: 12px;
}
</style>
